import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const VisaCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z'
        fill='white'
      />
      <path
        d='M22.3037 7.47803C23.1751 7.47805 23.8756 7.66814 24.4199 7.86572L24.0225 9.72119C23.0094 9.25496 22.1162 9.28715 21.792 9.32959C21.138 9.41474 20.839 9.74822 20.832 10.062C20.81 11.0932 24.0114 11.2206 24.002 13.5288C23.9947 15.347 22.4402 16.5218 20.0635 16.522C19.0519 16.5113 18.0756 16.2996 17.5469 16.0571L17.957 14.1401C18.4831 14.3847 19.143 14.7104 20.2803 14.6929C20.9315 14.6827 21.6281 14.4237 21.6348 13.8374C21.6381 13.4542 21.3427 13.1779 20.4609 12.7495C19.6037 12.3311 18.466 11.6288 18.4805 10.3696C18.4937 8.66727 20.0673 7.47803 22.3037 7.47803ZM30.1738 7.63818L32 16.3853H29.9082L29.6348 15.0786H26.7314L26.2598 16.3843H23.8848L27.2793 8.27979C27.4415 7.89104 27.808 7.63823 28.2422 7.63818H30.1738ZM7.90332 7.63818C8.39397 7.63818 8.83477 7.96486 8.94629 8.52979L9.89941 13.5913L12.2539 7.63818H14.6309L10.9648 16.3843H8.57324L6.76953 9.40479C6.66001 8.97486 6.56452 8.81736 6.23145 8.63623C5.68794 8.34121 4.79012 8.06389 4 7.89209L4.05371 7.63818H7.90332ZM15.9932 16.3843H13.7305L15.6025 7.63818H17.8643L15.9932 16.3843ZM27.3828 13.2856H29.2598L28.5742 10.0015L27.3828 13.2856Z'
        fill='#1434CB'
      />
    </svg>
  )
})
